import type { VNode } from "vue";
import Vue from "vue";
import ColumnFilterComponent from "@/components/controls/grid/columnfilters/ColumnFilterComponent.vue";
import type { CreateElement } from "vue/types/vue";
import type {
  FilterFunc,
  FilterState,
  FilterType,
} from "@/components/controls/grid/columnfilters/ColumnFilters";
import { buildApplyFilter } from "@/components/controls/grid/columnfilters/ColumnFilters";
import BmNumber from "@/components/controls/input/BmNumber.vue";

const numberFilterTypes: FilterType[] = [
  {
    type: "filter_equals",
    values: 1,
    applyFunc: (
      itemValue: any,
      formattedItemValue: any,
      filterValue: number | null
    ) =>
      filterValue != null
        ? !isNaN(Number(itemValue)) && Number(itemValue) === filterValue
        : true,
  },
  {
    type: "filter_not_equals",
    values: 1,
    applyFunc: (
      itemValue: any,
      formattedItemValue: any,
      filterValue: number | null
    ) =>
      filterValue != null
        ? !isNaN(Number(itemValue)) && Number(itemValue) !== filterValue
        : true,
  },
  {
    type: "filter_greater_than",
    values: 1,
    applyFunc: (
      itemValue: any,
      formattedItemValue: any,
      filterValue: number | null
    ) =>
      filterValue != null
        ? !isNaN(Number(itemValue)) && Number(itemValue) > filterValue
        : true,
  },
  {
    type: "filter_less_than",
    values: 1,
    applyFunc: (
      itemValue: any,
      formattedItemValue: any,
      filterValue: number | null
    ) =>
      filterValue != null
        ? !isNaN(Number(itemValue)) && Number(itemValue) < filterValue
        : true,
  },
];

export function buildApplyNumberFilter(state: FilterState): FilterFunc {
  return buildApplyFilter(state, numberFilterTypes);
}

export default Vue.extend({
  name: "NumberFilterComponent",
  components: { ColumnFilterComponent },
  render(h: CreateElement): VNode {
    return h(ColumnFilterComponent, {
      attrs: { ...this.$attrs },
      props: { filterTypes: numberFilterTypes },
      scopedSlots: {
        control1: (props: any) => {
          return h(BmNumber, {
            props: {
              defaultValue: null,
              value: props.value !== null ? Number(props.value) : null,
            },
            on: {
              input: (event: string | null) => {
                props.setValue(event);
              },
            },
          });
        },
        control2: (props: any) => {
          return h(BmNumber, {
            props: {
              defaultValue: null,
              value: props.value !== null ? Number(props.value) : null,
            },
            on: {
              input: (event: string | null) => {
                props.setValue(event);
              },
            },
          });
        },
      },
    });
  },
});
